import { render, staticRenderFns } from "./GridSample.vue?vue&type=template&id=1488b071&"
import script from "./GridSample.js?vue&type=script&lang=js&"
export * from "./GridSample.js?vue&type=script&lang=js&"
import style0 from "./GridSample.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports